var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',[_vm._v("Vous naviguez sur un appareil mobile, merci de vous connecter via votre\n      tablette ou ordinateur.")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }